/**
* @Author: Michael Neumair <mBook>
* @Date:   2016-09-27T10:46:06+02:00
* @Email:  7q7w7e7r@gmail.com
* @Last modified by:   mBook
* @Last modified time: 2016-10-06T20:31:36+02:00
*/


import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Control, Errors} from 'react-redux-form/src';
import MLabelInput from './../components/MLabelInput';
import AErrorInput from './../components/AErrorInput';
import MErrorGroupInput from './../components/MErrorGroupInput';
import OInputCurrency from './../components/OInputCurrency';
import shouldShowErrors from './shouldShowErrors';
import {
  createNumberMask,
  createNumberParser,
  createNumberFormatter,
} from './../masks/numberMask';


/**
 * OInputFieldCurrency - …
**/
class OInputFieldCurrency extends Component {
  constructor(props) {
    super(props);

    this.setMaskFunctions(props);
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.includeThousandsSeparator !== this.props.includeThousandsSeparator
            || nextProps.thousandsSeparatorSymbol !== this.props.thousandsSeparatorSymbol
            || nextProps.allowDecimal !== this.props.allowDecimal
            || nextProps.decimalSymbol !== this.props.decimalSymbol
    ) {
      this.setMaskFunctions(nextProps);
    }
  }

  render() {
    const {
      model,
      defaultValue,
      disabled,
      placeholder,
      validators,
      validateOn,
      asyncValidators,
      messages,
      showErrors,
      unit,
      label,
      description,
      toolLabel,
      toolIcon,
      onPressTool,
    } = this.props;

    return (
      <div className="o-input-field o-input-field-currency">
        <MLabelInput
          htmlFor={model}
          label={label}
          description={description}
          toolLabel={toolLabel}
          toolIcon={toolIcon}
          onPressTool={onPressTool}
          disabled={disabled}
        />
        <Control.text
          model={model}
          defaultValue={(typeof defaultValue === 'number') ? this.formatter(defaultValue) : undefined}
          component={OInputCurrency}
          validators={validators}
          validateOn={validateOn}
          asyncValidators={asyncValidators}
          parser={this.parser}
          withFieldValue={true}
          controlProps={{
            id: model,
            disabled,
            placeholder,
            unit,
            parser: this.parser,
            mask: this.mask,
            formatter: this.formatter,
          }}
          mapProps={{
            error: (props) => shouldShowErrors(showErrors, props),
            value: (props) => {
              // sets the value based on modelValue.
              // modelValue get the modelValue value, when modelValue
              // is changed in the store. this way we can check if we got a
              // number and has to format it. otherwise when we got a string,
              // it already is the modelValue without doing anything.
              if (typeof props.modelValue === 'string') {
                return props.modelValue;
              }
              return this.formatter(props.modelValue);
            },
          }}
        />
        <Errors
          model={model}
          messages={messages}
          wrapper={MErrorGroupInput}
          component={AErrorInput}
          show={showErrors}
        />
      </div>
    );
  }

  setMaskFunctions(props = this.props) {
    const {
      includeThousandsSeparator,
      thousandsSeparatorSymbol,
      allowDecimal,
      decimalSymbol,
    } = props;

    const fixedOptions = {
      prefix: '',
      suffix: '',
      decimalLimit: 2,
      requireDecimal: false,
      allowNegative: false,
    };

    const options = {
      includeThousandsSeparator,
      thousandsSeparatorSymbol,
      allowDecimal,
      decimalSymbol,
    };

    this.mask = createNumberMask({
      ...fixedOptions,
      ...options,
    });
    this.parser = createNumberParser({
      ...fixedOptions,
      ...options,
    });
    this.formatter = createNumberFormatter({
      ...fixedOptions,
      ...options,
      requireDecimal: false, // for the formatter we do not require the decimals
    });
  }
}
OInputFieldCurrency.propTypes = {
  /**
     * react-redux-form model
     * see: https://davidkpiano.github.io/react-redux-form/docs/guides/models.html
     */
  model: PropTypes.string.isRequired,
  /**
     * default value of the component
     */
  defaultValue: PropTypes.number,
  /**
     * disable the input
     */
  disabled: PropTypes.bool,
  /**
     * placeholder for input
     */
  placeholder: PropTypes.string,
  /**
     * hash with validator functions
     * see: https://davidkpiano.github.io/react-redux-form/docs/guides/validation.html
     */
  validators: PropTypes.object,
  /**
     * when validation should be fired
     * see: https://davidkpiano.github.io/react-redux-form/docs/guides/validation.html
     */
  validateOn: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
  ]),
  /**
     * hash with async validator functions
     * see: https://davidkpiano.github.io/react-redux-form/docs/guides/validation.html
     */
  asyncValidators: PropTypes.object,
  /**
     * error messages for validatiors
     * see: https://davidkpiano.github.io/react-redux-form/docs/guides/validation.html
     */
  messages: PropTypes.object,
  /**
     * when errors should be shown
     * function which gets passed the props of the form-model
     * see: https://davidkpiano.github.io/react-redux-form/docs/api/Errors.html#show
     */
  showErrors: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.bool,
  ]).isRequired,
  /**
     * show thousands seperator
     */
  includeThousandsSeparator: PropTypes.bool.isRequired,
  /**
     * seperator symbol
     */
  thousandsSeparatorSymbol: PropTypes.string.isRequired,
  /**
     * if a decimal value is allowed
     * default: true
     */
  allowDecimal: PropTypes.bool.isRequired,
  /**
     * symbol for decimal seperation
     */
  decimalSymbol: PropTypes.string.isRequired,
  /**
     * display a unit on the right
     */
  unit: PropTypes.string,
  /**
     * label and children are the same
     */
  label: PropTypes.string,
  /**
     * description for the input
     */
  description: PropTypes.any,
  /**
     * label for the tool-button, like 'Help'
     */
  toolLabel: PropTypes.string,
  /**
     * icon for the tool button like 'question-sign'
     */
  toolIcon: PropTypes.string,
  /**
     * displays a tool button with icon and fires
     * whe it is pressed. useful to show extra help infos
     */
  onPressTool: PropTypes.func,
};
OInputFieldCurrency.defaultProps = {
  validateOn: 'blur',
  includeThousandsSeparator: false,
  thousandsSeparatorSymbol: '.',
  allowDecimal: true,
  decimalSymbol: ',',
};
export default OInputFieldCurrency;

